package com.tregz.tremenz.ui.media

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.tregz.tremenz.io.player.PlayerMedia

/** Inset from the top of the container where tab overlay content sits. Null when unconstrained. */
val LocalPlayerOverlayTop = compositionLocalOf<Dp?> { null }

/** Renders the video output of [player] — a `SurfaceView` on Android, a `<video>` element on web. */
@Composable
expect fun MediaSurface(player: PlayerMedia, modifier: Modifier = Modifier)
